import { URLS } from '../../constants';
import apiClient from '../client';

const GetUserProfile = {
    userProfileData: (
        profileUserId: any = undefined,
        profileOrgId: any = undefined
    ) =>
        apiClient.post(URLS.userProfileData, {
            data: {
                profileUserId,
                profileOrgId,
            },
        }),
    userchildById: ({ id }: { id: any }) =>
        apiClient.post(URLS.getUserChiildByid, {
            data: {
                id,
            },
        }),
    getAllChild: () =>
        apiClient.post(URLS.getAllChild, {
            data: {},
        }),
    getParticularChild: ({ id }: { id: any }) =>
        apiClient.post(URLS.getParticularChild, {
            data: { id },
        }),
    getEthinicity: () =>
        apiClient.post(URLS.getEthinicity, {
            data: {},
        }),
    saveChild: ({
        id,
        changeStatus,
        data,
    }: {
        id: any;
        changeStatus: any;
        data: any;
    }) =>
        apiClient.post(URLS.saveChild, {
            data: {
                id,
                changeStatus,
                data,
            },
        }),
};

export default GetUserProfile;
